import { isCorpTenant, replaceObjectValues } from "@capone/common";
import axios from "axios";
import {
  CREATED_TRAVELER_PROFILE,
  HotelLoyaltyMap,
  IPerson,
  TravelerProfileProperties,
  UPDATED_TRAVELER_PROFILE,
} from "redmond";
import { ToggleActions } from "halifax";
import { config } from "../../config";
import { trackEvent } from "../analytics/trackEvent";
import { passengersApiPrefix } from "../paths";

const END_POINT: string = `${passengersApiPrefix}/update`;

export interface IUpdateUserPassengerRequest {
  person: IPerson;
  isNewTraveler?: boolean;
  source?: string;
  hideProfileAction?: ToggleActions;
  entryPoint?: string;
  previousHotelLoyalty?: HotelLoyaltyMap;
}

export interface IUpdateUserPassengerResponse {}

export const updateUserPassenger = (
  body: IUpdateUserPassengerRequest
): Promise<IUpdateUserPassengerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const {
        isNewTraveler,
        hideProfileAction,
        entryPoint,
        person,
        previousHotelLoyalty,
        ...payload
      } = body;

      const cleanPersonPayload = replaceObjectValues(person, "", null);

      const res = await axios.put(
        END_POINT,
        {
          ...payload,
          person: cleanPersonPayload,
        },
        {
          baseURL: config.baseURL,
        }
      );

      const responseBody: IUpdateUserPassengerResponse = res.data;
      resolve(responseBody);

      if (isCorpTenant(config.TENANT)) {
        const frequentFlyerProgramsAmount = Reflect.ownKeys(
          body.person.frequentFlyer
        ).length;
        const hotelLoyaltyProgramsAmount = Reflect.ownKeys(
          body.person.hotelLoyalty
        ).length;
        const carLoyaltyProgramsAmount = Reflect.ownKeys(
          body.person.groundLoyalty ?? {}
        ).length;

        const previousHotelLoyaltyKeys = Object.keys(previousHotelLoyalty || {});
        const newHotelLoyaltyKeys = Object.keys(body.person.hotelLoyalty || {});
        const hotelLoyaltyProgramsAdded = newHotelLoyaltyKeys.filter(
          (k) => !previousHotelLoyaltyKeys.includes(k)
        );
        const hotelLoyaltyProgramsRemoved = previousHotelLoyaltyKeys.filter(
          (k) => !newHotelLoyaltyKeys.includes(k)
        );

        trackEvent({
          eventName: isNewTraveler
            ? CREATED_TRAVELER_PROFILE
            : UPDATED_TRAVELER_PROFILE,
          properties: {
            frequent_flyer_added: frequentFlyerProgramsAmount > 0,
            num_frequent_flyer_programs: frequentFlyerProgramsAmount,
            hotel_loyalty_program_added: hotelLoyaltyProgramsAdded.length > 0,
            num_hotel_loyalty_programs: hotelLoyaltyProgramsAmount,
            hotel_loyalty_programs_added: hotelLoyaltyProgramsAdded,
            hotel_loyalty_programs_removed: hotelLoyaltyProgramsRemoved,
            car_loyalty_program_added: carLoyaltyProgramsAmount > 0,
            source: body.source,
            private: hideProfileAction === ToggleActions.ON,
            entry_point: entryPoint,
          } satisfies TravelerProfileProperties,
        });
      }
    } catch (e) {
      reject(e);
    }
  });
